import { useCallback } from 'react';
import QuizQuestion from './QuizQuestion';
import Raven from 'raven-js';
import { useClearQuizAnswer, useRecentQuizAttempt } from '../quizQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const reportError = (checkName, extra) => {
  Raven.captureMessage(`QuizQuestionContainer : Cannot read property 'get' of '${checkName}'`, {
    extra
  });
};
const QuizQuestionContainer = ({
  lessonId,
  quizId,
  onSelectAnswers,
  onTryAgainClick,
  question,
  selectedAnswerIds
}) => {
  const {
    recentQuizAttempt
  } = useRecentQuizAttempt(lessonId, quizId);
  const clearAnswer = useClearQuizAnswer();
  const answers = question.answers;
  const hasAttempt = !!recentQuizAttempt && !!recentQuizAttempt.answerSubmissions;
  let hasAnswered = false;
  let correctAnswer = false;
  let feedbackText = undefined;
  let questionId = undefined;
  if (hasAttempt) {
    const maybeAnswerSubmission = recentQuizAttempt.answerSubmissions.find(answerSubmission => {
      if (!question) {
        reportError('question', {
          attempt: recentQuizAttempt
        });
        return false;
      }
      return answerSubmission.questionId === question.id;
    });
    hasAnswered = !!maybeAnswerSubmission;
    if (hasAnswered) {
      correctAnswer = maybeAnswerSubmission.correctAnswer;
      questionId = maybeAnswerSubmission.questionId;
      feedbackText = correctAnswer ? question.correctResponse : question.incorrectResponse;
    }
  }
  const id = question.id;
  const image = question.image;
  const imageAlt = question.imageAlt;
  const title = question.question;
  const type = question.questionType;
  const handleTryAgainClick = useCallback(() => {
    if (recentQuizAttempt && questionId) {
      clearAnswer(lessonId, recentQuizAttempt.id, questionId);
      onTryAgainClick();
    }
  }, [recentQuizAttempt, questionId, clearAnswer, lessonId, onTryAgainClick]);
  return /*#__PURE__*/_jsx(QuizQuestion, {
    answers: answers,
    correctAnswer: correctAnswer,
    feedbackText: feedbackText,
    hasAnswered: hasAnswered,
    id: id,
    image: image || undefined,
    imageAlt: imageAlt,
    onSelectAnswer: onSelectAnswers,
    onTryAgainClick: handleTryAgainClick,
    selectedAnswerIds: selectedAnswerIds,
    title: title,
    type: type
  });
};
export default QuizQuestionContainer;